import type { ReactNode } from 'react'
import { useModeStore } from '@stores/modeStore.js'
import { GuiaPageHeader } from './GuiaPageHeader.js'
import { ObraPageHeader } from './ObraPageHeader.js'

interface Props {
  title: string
  subtitle?: string
  children?: ReactNode
  /** intro = subtítulo abaixo do título fixo do header; hero = banner editorial completo */
  variant?: 'intro' | 'hero'
}

/** Cabeçalho que segue o modo ativo (Guia ou Obra). */
export function ModePageHeader({ title, subtitle, children, variant = 'intro' }: Props) {
  const mode = useModeStore((s) => s.mode)

  if (variant === 'intro') {
    return (
      <div className='cf3-page-intro' aria-label={title}>
        {subtitle && <p className='cf3-page-intro__desc'>{subtitle}</p>}
        {children && <div className='cf3-page-intro__actions'>{children}</div>}
      </div>
    )
  }

  if (mode === 'guia') {
    return (
      <GuiaPageHeader title={title} {...(subtitle ? { subtitle } : {})}>
        {children}
      </GuiaPageHeader>
    )
  }
  return (
    <ObraPageHeader title={title} {...(subtitle ? { subtitle } : {})}>
      {children}
    </ObraPageHeader>
  )
}
